import { render, staticRenderFns } from "./PremiumServicesAppointments.vue?vue&type=template&id=2d95ecd2"
import script from "./PremiumServicesAppointments.ts?vue&type=script&lang=ts&external"
export * from "./PremiumServicesAppointments.ts?vue&type=script&lang=ts&external"
import style0 from "./PremiumServicesAppointments.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports